import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import LogPage from "./pages/LogPage";
import StudentPage from "./pages/StudentPage";
import ExaminerPage from "./pages/ExaminerPage";
import GroupPage from "./pages/GroupPage";
import UpperBar from "./components/UpperBar";
import SideBar from "./components/SideBar";
import { ElemProvider } from "./Contexts/ElemContext";
import { checkAdmin } from "./utils/jwtUtils";
import SummaryPage from "./pages/SummaryPage";
import AdminPage from "./pages/AdminPage";
import AxiosProvider from "./providers/AxiosProvider";
import FeedbackBar from "./components/FeedbackBar";
import { FeedbackProvider, useFeedback } from "./Contexts/FeedbackContext";
import { TOKEN_KEY } from "./constants/storageKey";
import { HelmetProvider } from "react-helmet-async";

function ProtectedRoute({ element }) {
  const isAuthenticated = !!localStorage.getItem(TOKEN_KEY);

  return isAuthenticated ? element : <Navigate to="/login" />;
}

function AdminRoute({ element }) {
  const isAdmin = checkAdmin();
  return isAdmin ? element : <Navigate to="/student" />;
}

function App() {
  return (
    <Router>
      <HelmetProvider>
        <ElemProvider>
          <AxiosProvider>
            <FeedbackProvider>
              <AppContent />
            </FeedbackProvider>
          </AxiosProvider>
        </ElemProvider>
      </HelmetProvider>
    </Router>
  );
}

function AppContent() {
  const { feedback } = useFeedback();

  return (
    <>
      <UpperBar />
      <SideBar />
      {feedback && (
        <FeedbackBar message={feedback.message} success={feedback.success} />
      )}
      <Routes>
        <Route
          path="*"
          element={<ProtectedRoute element={<Navigate to={"/log"} />} />}
        />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/log"
          element={
            <AdminRoute element={<ProtectedRoute element={<LogPage />} />} />
          }
        />
        <Route
          path="/student"
          element={<ProtectedRoute element={<StudentPage />} />}
        />
        <Route
          path="/examiner"
          element={
            <AdminRoute
              element={<ProtectedRoute element={<ExaminerPage />} />}
            />
          }
        />
        <Route
          path="/group"
          element={
            <AdminRoute element={<ProtectedRoute element={<GroupPage />} />} />
          }
        />
        <Route
          path="/summary"
          element={
            <AdminRoute
              element={<ProtectedRoute element={<SummaryPage />} />}
            />
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute element={<ProtectedRoute element={<AdminPage />} />} />
          }
        />
      </Routes>
    </>
  );
}

export default App;
